import {Injectable} from "@angular/core";
import {HttpHeaders} from "@angular/common/http";
import {Router} from "@angular/router";
import {JwtHelperService} from "@auth0/angular-jwt";
import {AccountService} from "./account.service";
import {AuthControllerService} from "../api/controllers/auth-controller/auth-controller.service";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  static readonly EXERCISES_COLLAPSED_CATEGORIES_STORAGE_KEY =
    "exercisesCollapsedCategories";

  constructor(
    private authController: AuthControllerService,
    private router: Router,
    private accountService: AccountService,
    private jwtHelper: JwtHelperService
  ) {
  }

  static getOauthTokenFromStorage() {
    return localStorage.getItem("token") || sessionStorage.getItem("token");
  }

  static getOauthRefreshTokenFromStorage() {
    return (
      localStorage.getItem("refresh_token") ||
      sessionStorage.getItem("refresh_token")
    );
  }

  static clearStorageData() {
    AuthService.removeOauthTokenFromStorage();
    AuthService.removeOauthRefreshTokenFromStorage();
    AuthService.removeSelectedLocationIdFromStorage();
    localStorage.removeItem(
      AuthService.EXERCISES_COLLAPSED_CATEGORIES_STORAGE_KEY,
    );
    localStorage.removeItem('settings');
  }

  static removeOauthTokenFromStorage() {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
  }

  static removeOauthRefreshTokenFromStorage() {
    localStorage.removeItem("refresh_token");
    sessionStorage.removeItem("refresh_token");
  }

  static removeSelectedLocationIdFromStorage(): void {
    localStorage.removeItem("selectedLocationId");
    sessionStorage.removeItem("selectedLocationId");
  }

  static defaultTokenHeader() {
    return { headers: AuthService.setTokenHeader() };
  }

  static setTokenHeader(): HttpHeaders {
    return new HttpHeaders().set(
      "Authorization",
      "Bearer " + AuthService.getOauthTokenFromStorage(),
    );
  }

  static setSelectedLocationId(newSelectedLocationId: string) : void {
    if (AuthService.getSelectedLocationId() !== newSelectedLocationId) {
      localStorage.removeItem(
        AuthService.EXERCISES_COLLAPSED_CATEGORIES_STORAGE_KEY,
      );
    }
    localStorage.setItem("selectedLocationId", newSelectedLocationId);
  }

  static getSelectedLocationId(): string {
    return localStorage.getItem("selectedLocationId");
  }

  loggedIn() {
    return !this.jwtHelper.isTokenExpired(
      AuthService.getOauthTokenFromStorage(),
    );
  }

  checkTokenAccess(role: string): boolean {
    const local_token = AuthService.getOauthTokenFromStorage();

    if (local_token !== null) {
      const token = this.jwtHelper.decodeToken(local_token);

      if (token.roles != null) {
        return !!token.roles.includes(role);
      }
    }
    return false;
  }

  checkAcconutType(type): boolean {
    const local_token = AuthService.getOauthTokenFromStorage();
    if (local_token != null) {
      const token = this.jwtHelper.decodeToken(local_token);
      if (token.accountType != null) {
        return token.accountType == type;
      }
    }
    return false;
  }

  logout() {
    this.authController.logout().subscribe();
    AuthService.clearStorageData();
    this.router.navigate(["/login"]);
  }
}
